import { render, staticRenderFns } from "./Followind2.vue?vue&type=template&id=c87e88f4&scoped=true&"
import script from "./Followind2.vue?vue&type=script&lang=js&"
export * from "./Followind2.vue?vue&type=script&lang=js&"
import style0 from "./Followind2.vue?vue&type=style&index=0&id=c87e88f4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c87e88f4",
  null
  
)

export default component.exports